import React, { useState } from 'react';
import { useDemoPage } from "@/lib/useDemoPage";
import { useTranslation } from 'react-i18next';
import BlockchainShowcase from './BlockchainShowcase';
import '../styles/BlockchainDemoPage.css';

const BlockchainDemoPage = () => {
  useDemoPage("blockchain");
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || i18n.language || 'fr';
  const [selectedRole, setSelectedRole] = useState('premium');

  const roles = [
    { value: 'standard', label: t('blockchainDemo.roles.standard'), price: 29 },
    { value: 'premium', label: t('blockchainDemo.roles.premium'), price: 199 },
    { value: 'artAdvisor', label: t('blockchainDemo.roles.artAdvisor'), price: 99 },
    { value: 'artAdvisorPrm', label: t('blockchainDemo.roles.artAdvisorPremium'), price: 199 },
    { value: 'familyOffice', label: t('blockchainDemo.roles.familyOffice'), price: 299 }
  ];
  const formatMonthlyPrice = (price) => t('blockchainDemo.monthlyPrice', {
    price: new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(price),
  });

  return (
    <div className="blockchain-demo-page">
      {/* Barre de sélection de rôle */}
      <div className="role-selector-bar">
        <div className="selector-container">
          <div className="selector-label">
            <span className="label-icon">👤</span>
            <span>{t("blockchainDemo.selectorLabel")}</span>
          </div>
          <div className="role-buttons">
            {roles.map((role) => (
              <button
                key={role.value}
                className={`role-button ${selectedRole === role.value ? 'active' : ''}`}
                onClick={() => setSelectedRole(role.value)}
              >
                <span className="role-name">{role.label}</span>
                <span className="role-price">{formatMonthlyPrice(role.price)}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Composant BlockchainShowcase */}
      <BlockchainShowcase userRole={selectedRole} />

      {/* Section d'information complémentaire */}
      <div className="demo-footer">
        <div className="footer-content">
          <h2>{t("blockchainDemo.footer.title")}</h2>
          <p>
            {t("blockchainDemo.footer.text")}
          </p>
          <div className="footer-actions">
            <button className="primary-action">{t("blockchainDemo.footer.startTrial")}</button>
            <button className="secondary-action">{t("blockchainDemo.footer.scheduleDemo")}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockchainDemoPage;